/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Top_CategoryInputs */

const en_directory_launch_top_category = /** @type {(inputs: Directory_Launch_Top_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top category`)
};

const zh_directory_launch_top_category = /** @type {(inputs: Directory_Launch_Top_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`热门分类`)
};

/**
* | output |
* | --- |
* | "Top category" |
*
* @param {Directory_Launch_Top_CategoryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_top_category = /** @type {((inputs?: Directory_Launch_Top_CategoryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Top_CategoryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_top_category(inputs)
	return zh_directory_launch_top_category(inputs)
});
export { directory_launch_top_category as "directory.launch.top_category" }